import type { UnifiedGroup } from '../..';

/**
 * Check whether the group belongs to Joined section of the hub
 * @param hubPersona the given HubPersona
 */
export function isJoinedGroup(group: UnifiedGroup): boolean {
    return group && group.isOwner === false && !group.whenSoftDeletedTime;
}

/**
 * Check whether the group belongs to Owned section of the hub
 * @param hubPersona the given HubPersona
 */
export function isOwnedGroup(group: UnifiedGroup): boolean {
    return group && group.isOwner === true && !group.whenSoftDeletedTime;
}

/**
 *  Check whether the group belongs to Deleted section of the hub
 * @param hubPersona the given HubPersona
 */
export function isDeletedGroup(group: UnifiedGroup): boolean {
    return group && !!group.whenSoftDeletedTime;
}

/**
 * Check whether the groupId is in list of the groupIds
 * @param groupId group id to search for
 * @param groupIds group ids list
 */
export function isGroupInList(groupId: string, groupIds: string[]): boolean {
    return groupIds && groupIds.some(x => x === groupId);
}
